var map = {
	"./Aleo-Bold.ttf": 129,
	"./Aleo-BoldItalic.ttf": 130,
	"./Aleo-Italic.ttf": 131,
	"./Aleo-Light.ttf": 132,
	"./Aleo-LightItalic.ttf": 133,
	"./Aleo-Regular.ttf": 134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;